import { Injectable } from '@angular/core';
import { PageLayoutHandler } from '@spartacus/storefront';
import { combineLatest, Observable, of } from 'rxjs';
import {ActiveCartService, CartConfigService, isEmpty, SelectiveCartService} from '@spartacus/cart/base/core';
import {Cart} from '@spartacus/cart/base/root';
import {map, startWith} from "rxjs/operators";


@Injectable({
  providedIn: 'root',
})
export class UigCartPageLayoutHandler implements PageLayoutHandler {
  constructor(
    protected activeCartService: ActiveCartService,
    protected selectiveCartService: SelectiveCartService,
    protected cartConfig: CartConfigService
  ) {
  }

    handle(
        slots$: Observable<string[]>,
        pageTemplate?: string,
        section?: string
    ) {
        if (pageTemplate === 'CartPageTemplate' && !section) {
            return combineLatest([
                slots$,
                this.activeCartService.getActive(),
                this.cartConfig.isSelectiveCartEnabled()
                    ? this.selectiveCartService.getCart().pipe(startWith(null))
                    : of({} as Cart),
                this.activeCartService.getLoading(),
            ]).pipe(
                map(([slots, cart, selectiveCart, loadingCart]) => {
                    const exclude = (arr: string[], args: string[]) =>
                        arr.filter((item) => args.every((arg) => arg !== item));
                    return isEmpty(cart) && loadingCart
                        ? exclude(slots, [
                            'TopContent',
                            'CenterLeftContentSlot',
                            'CenterRightContentSlot',
                            'EmptyCartMiddleContent',
                            'BottomContentSlot'
                        ])
                        : cart.totalItems
                            ? exclude(slots, ['EmptyCartMiddleContent'])
                            : selectiveCart?.totalItems
                                ? exclude(slots, [
                                    'EmptyCartMiddleContent',
                                ])
                                : exclude(slots, ['CenterLeftContentSlot']);
                })
            );
        }
        return slots$;
    }
}
